import { IListOrganizador } from "../components/interfaces";
import checkout from "./forms";

const {
  formField: {
    cnpj,
    cpf,
    nomeFantasia,
    razaoSocial,
    urlFacebook,
    urlInstagram,
    urlTwitter,
    urlSite,
    mediaSocialPageEvento,
    celPhone1,
    celPhone2,
    telefone,
    email,
    cep,
    logradouro,
    numero,
    bairro,
    cidade,
    uf,
    complemento,
    password,
    confirmPassword,
    tipoPessoa,
  },
} = checkout;

const initialValuesEdit = (data: IListOrganizador | null) => {
  return {
    [cnpj.name]: data.cnpj || "",
    [cpf.name]: data.cpf || "",
    [nomeFantasia.name]: data.nomeFantasia || "",
    [razaoSocial.name]: data.razaoSocial || "",
    [urlFacebook.name]: data.urlFacebook || "",
    [urlInstagram.name]: data.urlInstagram || "",
    [urlTwitter.name]: data.urlTwitter || "",
    [urlSite.name]: data.urlSite || "",
    [mediaSocialPageEvento.name]: String(data.mediaSocialPageEvento) || "false",
    [celPhone1.name]: data.celPhone1 || "",
    [celPhone2.name]: data.celPhone2 || "",
    [telefone.name]: data.telefone || "",
    [email.name]: data.email || "",
    [cep.name]: data.enderecos[0].cep || "",
    [logradouro.name]: data.enderecos[0].endereco || "",
    [numero.name]: data.enderecos[0].numero || "",
    [bairro.name]: data.enderecos[0].bairro || "",
    [cidade.name]: data.enderecos[0].cidade || "",
    [uf.name]: data.enderecos[0].uf || "",
    [complemento.name]: data.enderecos[0].complemento || "",
    [password.name]: data.password || "",
    [confirmPassword.name]: data.confirmPassword || "",
    [tipoPessoa.name]: data.tipoPessoa.tipo || "",
  };
};
const initialValues = {
  [cnpj.name]: "",
  [cpf.name]: "",
  [nomeFantasia.name]: "",
  [razaoSocial.name]: "",
  [urlFacebook.name]: "",
  [urlInstagram.name]: "",
  [urlTwitter.name]: "",
  [urlSite.name]: "",
  [mediaSocialPageEvento.name]: "false",
  [celPhone1.name]: "",
  [celPhone2.name]: "",
  [telefone.name]: "",
  [email.name]: "",
  [cep.name]: "",
  [logradouro.name]: "",
  [numero.name]: "",
  [bairro.name]: "",
  [cidade.name]: "",
  [uf.name]: "",
  [complemento.name]: "",
  [password.name]: "",
  [confirmPassword.name]: "",
  [tipoPessoa.name]: "",
};

export { initialValues, initialValuesEdit };
